var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-banner",class:[_vm.size],style:(_vm.mapPosition),on:{"click":_vm.handleClick}},[_c('p',{staticClass:"tiny-text"},[_vm._v(" "+_vm._s(_vm.parsedText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }